<h1 mat-dialog-title>Gerar boleto</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: '700';">
  <form [formGroup]="boletoForm">
    <div class="borda">
      <div class="row">
        <div class="col-auto">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Valor</mat-label>
            <input matInput currencyMask
              [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
              formControlName="valor" maxlength="20" required>
            <mat-error *ngIf="f.valor.errors?.required">
              Campo obrigatório
            </mat-error>

            <mat-error *ngIf="f.valor.errors?.min">
              O Valor não pode ser R$ 0,00
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-auto">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Data de vencimento</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dataVencimento" [min]="minDate"
              (dateChange)="dateChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>

            <mat-error *ngIf="f.dataVencimento.errors?.required">
              Campo obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field appearance="fill" [floatLabel]="'always'" disabled>
            <mat-label>Prazo solicitado</mat-label>
            <input type="text" matInput formControlName="prazoBoleto">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <mat-form-field appearance="outline" [floatLabel]="'always'">
            <mat-label>Observação</mat-label>
            <input type="text" matInput formControlName="observacao" maxlength="150">
            <mat-hint align="start">
              <strong>* Observação local (não irá aparecer no boleto);</strong>
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>

  <mat-divider></mat-divider>

  <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
    <button mat-flat-button color="warn" (click)="cancelar()">
      <mat-icon>clear</mat-icon> Cancelar
    </button>
    <button mat-flat-button color="primary" (click)="confirmarGerarBoleto()">
      <mat-icon>check</mat-icon> Gerar boleto
    </button>
  </section>
</div>
